import React from "react";
import PointTarget from 'react-point';
import NnSounds from "../music/NnSounds";
import NnKeyConstants from '../music/NnKeyConstants';
import "./PianoKeyAnimations.scss";

const styles = {
  transition: "all 0.5s ease-in"
};

class NnPianoKey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      octave: props.octave,
      active: props.active
    };

    this.play = this.play.bind(this);
  }

  render() {
    // TODO use props.active somehow
    const {keyName, letters} = this.props;
    const noteCss = this.state.active ? "active" : "";
    const keyNumber = NnKeyConstants.getKeyNumber(keyName);
    return (
      <PointTarget onPoint={()=>this.play()}>
        <div className={this.getClassNames(keyNumber)} style={{...styles, opacity: this.state.opacity}}>
          <span className={"key-label " + noteCss} >{this.getLabel(keyName, this.state.octave, letters)}</span>
        </div>
      </PointTarget>
    );
  }

  getLabel(keyname, octave, displayLetters) {
    return NnKeyConstants.getDisplayName(keyname, octave, displayLetters);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.octave !== this.state.octave ||
      nextProps.active !== this.state.active
    ) {
      this.setState({ active: nextProps.active, octave: nextProps.octave });
    }
  }

  // concatenate all state values that need to render as class names for this key
  getClassNames(keyNumber) {
    return [
      "piano-key",
      `key${keyNumber}`,
      this.props.keyName,
      this.props.black ? "black" : "white",
      this.state.active ? "active" : "",
      "keyPress",

    ].join(" ");
  }

  play() {
    NnSounds.play(this.props.keyName, this.state.octave);
    this.props.onKeyPress(this.props.keyName, this.state.octave);
  }
}
export default NnPianoKey;
